import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
// import Wrp from "../../hoc/Wrp/Wrp";

class CheckboxField extends Component {
  
  fieldOnChangeHandler(e){
    const {changeHandler} = this.props;
    changeHandler(e.target.checked);
  } 

  render() {
    const {value,isDefault} = this.props;
    let attr = setAndGetAttributes(this.props);
    if(isDefault===true){
      return(
        <>
         <input 
              type="checkbox" 
              checked={(value==='true')?true:(value==='TRUE' || value===true)?true:(value==='false')?false:value}
              onChange={e=>this.fieldOnChangeHandler(e)}
              {...attr}
              // className=''
          /> 
          </>
      )
    }else{
      return (
        <div className="custom-control custom-checkbox pb-2">
          <input 
              onChange={e=>this.fieldOnChangeHandler(e)}
              checked={(value==='true')?true:(value==='TRUE' || value===true)?true:(value==='false')?false:value}
              type="checkbox" 
              className="custom-control-input" 
              {...attr} />
              <label 
                className="custom-control-label" 
                htmlFor={attr.readOnly === false ? attr.id : null}
                style={{...attr.style}} ></label>
        </div>
             
      );
    }
  }
}

CheckboxField.defaultProps = {
  isDefault:true,
  id:'defCheckbox',
  disabled: false,
  readOnly:false,
  className: 'custom-control-input'
}

export default CheckboxField;